import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Image from '../../components/ContentfulImage';
import Placeholder from '../../components/Placeholder';

import {
  Section,
  Title,
  TreatmentsWrapper,
  Treatments,
  Treatment,
  TreatmentImage,
  TreatmentDetails,
  TreatmentName,
  TreatmentDescription,
  TreatmentFootnote,
  TreatmentDuration,
  TreatmentLink,
} from './ReleatedTreatments.style';

const ReleatedTreatments = ({ copy, locale, treatments }) => (
  <Section>
    <Title>{copy.more_treatment || <Placeholder w="100px" h="20px" />}</Title>

    <TreatmentsWrapper>
      <Treatments>
        {treatments.map(treatment => (
          <Treatment key={treatment.entryId || treatment.key}>
            <TreatmentImage>
              {treatment.procedure ? (
                <Image src={treatment.procedure[0].image} options={{ w: '100%', size: [500, 800, 250] }} />
              ) : (
                <Placeholder h="160px" w="100%" />
              )}
            </TreatmentImage>
            <TreatmentDetails>
              <TreatmentName>{treatment.name || <Placeholder h="20px" w="250px" />}</TreatmentName>
              <TreatmentDescription>{treatment.description || <Placeholder h="80px" w="100%" />}</TreatmentDescription>
              <TreatmentFootnote>
                <TreatmentDuration>
                  {treatment.duration ? `Duration: ${treatment.duration} Minutes` : <Placeholder h="15px" w="60%" />}
                </TreatmentDuration>
                <TreatmentLink>
                  {treatment.slug ? (
                    <Link to={`/${locale}/treatment/${treatment.slug}`} href={`/${locale}/treatment/${treatment.slug}`}>
                      {copy.view_details || <Placeholder w="100px" h="20px" />}
                    </Link>
                  ) : (
                    <Placeholder h="15px" w="100px" />
                  )}
                </TreatmentLink>
              </TreatmentFootnote>
            </TreatmentDetails>
          </Treatment>
        ))}
      </Treatments>
    </TreatmentsWrapper>
  </Section>
);

ReleatedTreatments.defaultProps = {
  copy: {},
};

ReleatedTreatments.propTypes = {
  copy: PropTypes.shape(),
  locale: PropTypes.string.isRequired,
  treatments: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

const mapState = state => ({
  copy: state.siteOptions.siteCopyTreatmentPage,
  locale: state.locale,
});

export default connect(mapState)(ReleatedTreatments);



// WEBPACK FOOTER //
// ./src/pages/TreatmentPage/ReleatedTreatments.js